import { useDispatch } from "react-redux"
import { isEmpty } from 'lodash';
// actions
import LanguageServiceAction from "@/core/actions/common/LanguageServiceAction";
import CoreAction from "@/core/actions/common/CoreAction";


const useClientLanguage = () => {
    const dispatch = useDispatch();

    const coreAction = new CoreAction(dispatch);
    const languageServiceAction = new LanguageServiceAction(dispatch);

    const armadorStaticPayload = document?.getElementById('ARMADORStaticPayload')?.textContent;
    const _armadorStaticPayload = JSON.parse(armadorStaticPayload||"");

    if ( !isEmpty(_armadorStaticPayload) ) {
        languageServiceAction.listStore({ payload:_armadorStaticPayload["languages"] });
        coreAction.setWebApplicationLanguage(_armadorStaticPayload["language"]);

        return _armadorStaticPayload["language"];
    }

    return null;
}

export default useClientLanguage;
